<template>
  <div v-loading="loading" class="table">
    <virtual-scroll
      :data="segmentData"
      :item-size="62"
      key-prop="id"
      @change="(renderData) => (dataList = renderData)"
    >
      <el-table
        class="loadmore-table"
        :class="loading ? 'no-empty' : ''"
        stripe
        :data="dataList"
        height="500px"
      >
        <el-table-column align="center" width="55px">
          <template slot-scope="{ row }">
            <el-checkbox
              v-model="row.isCheck"
              class="checkBox"
              :indeterminate="row.isIndeterminate"
              @change="handleCheckAllChange(row.index)"
            ></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column
          label="客户单号"
          prop="referenceNumber"
          align="center"
          width="260px"
        ></el-table-column>
        <el-table-column
          label="主单号"
          prop="mstTrackingNumber"
          align="center"
          width="200px"
        ></el-table-column>
        <el-table-column
          label="件数"
          prop="children"
          align="center"
          width="200px"
        >
          <template slot-scope="{ row }">
            {{ row.children?.length || 1 }}
          </template>
        </el-table-column>
        <el-table-column
          label="上传时间"
          prop="uploadTime"
          align="center"
          width="200px"
        ></el-table-column>
        <el-table-column label="操作" align="center" width="150px">
          <template slot-scope="{ row }">
            <el-button
              v-show="row.children?.length > 1"
              type="text"
              @click="open(row.index, row.isCollapse)"
            >
              {{ row.isCollapse ? "收起" : "展开" }}
            </el-button>
            <div v-show="row.isCollapse" class="content">
              <div class="title">选择子单号</div>
              <div
                class="order-items"
                :style="{
                  width: size === 'small' ? '100%' : 'calc(100% - 200px)',
                }"
              >
                <div
                  v-for="order in row?.children"
                  :key="order.trackingNumber"
                  class="order"
                >
                  <el-checkbox
                    v-model="order.isCheck"
                    @change="handleCheckOrderChange(row.index)"
                  ></el-checkbox>
                  <span
                    class="lable"
                    :class="[
                      { checked: order.isCheck, uncheck: !order.isCheck },
                    ]"
                  >
                    {{ order.trackingNumber }}
                  </span>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <div slot="append">
          <InfiniteLoading
            v-if="dialogVisible"
            forceUseInfiniteWrapper=".loadmore-table .el-table__body-wrapper"
            @infinite="loadMore"
          >
            <span slot="no-more"></span>
            <span slot="no-result"></span>
          </InfiniteLoading>
        </div>
      </el-table>
    </virtual-scroll>
    <!-- <div class="header">
      <div class="cell" style="width: 30%">客户单号</div>
      <div class="cell">主单号</div>
      <div class="cell">件数</div>
      <div class="cell">上传时间</div>
      <div class="cell" style="width: 10%">操作</div>
      <div class="scoll"></div>
    </div>
    <div class="tbody">
      <div v-for="(item, $index) in dataList" :key="$index" class="row">
        <div class="top">
          <div class="cell">
            <el-checkbox
              v-model="item.isCheck"
              class="checkBox"
              :indeterminate="item.isIndeterminate"
              @change="handleCheckAllChange($index)"
            ></el-checkbox>
            <p>{{ item.referenceNumber }}</p>
          </div>
          <div class="cell">
            <p>{{ item.mstTrackingNumber }}</p>
          </div>
          <div class="cell">
            <p>{{ item.children.length || 1 }}</p>
          </div>
          <div class="cell">
            <p>{{ item.uploadTime }}</p>
          </div>
          <div class="cell">
            <el-button
              v-if="item.children.length > 1"
              type="text"
              @click="open($index, item.isCollapse)"
            >
              {{ item.isCollapse ? "收起" : "展开" }}
            </el-button>
          </div>
        </div>
        <div v-if="item.isCollapse" class="content">
          <div class="title">选择子单号</div>
          <div class="order-items" :style="{'width': size === 'small' ? '100%' : 'calc(100% - 200px)'}">
            <div
              v-for="order in item.children"
              :key="order.trackingNumber"
              class="order"
            >
              <el-checkbox
                v-model="order.isCheck"
                @change="handleCheckOrderChange($index)"
              ></el-checkbox>
              <span
                class="lable"
                :class="[{ checked: order.isCheck, uncheck: !order.isCheck }]"
              >
                {{ order.trackingNumber }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>
<script>
import VirtualScroll from 'el-table-virtual-scroll'
import InfiniteLoading from 'vue-infinite-loading'
let sourceData
import { getUnboundMblOrders } from '@/api/fee'
import { throttle } from '@/utils/common'
export default {
  components: {
    VirtualScroll,
    InfiniteLoading
  },
  props: {
    size: {
      type: String,
      default: 'normal' // normal small
    },
    rowData: {
      type: Object,
      default: () => {
        return {
          blNo: 'MATS123124'
        }
      }
    },
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dataList: [],
      loading: false,
      list: [],
      segmentData: [],
      segmentIndex: -1,
      pagerConfig: {
        pageIndex: 0,
        pageSize: 5000
      },
      listStatus: true,
      containsArr: [],
      state: null
    }
  },
  watch: {
    // dialogVisible: {
    //   handler(val) {
    //     if (val) {
    //       this.infiniteId = +new Date()
    //     }
    //   },
    //   immediate: true
    // }
  },
  methods: {
    async getUnbindList(params, type) {
      this.loading = true
      try {
        params = {
          ...params,
          queryParam: {
            companyId: this.rowData.companyId,
            containsArr: this.containsArr?.length
              ? this.containsArr
              : undefined
          }
        }
        const res = await getUnboundMblOrders(params)
        this.loading = false
        if (res.success) {
          const data = res.data.list
          const arr = []
          if (
            data?.length === 0 &&
            this.listStatus
          ) {
            this.listStatus = false
          }
          data?.length &&
            data.forEach((item, index) => {
              const zIndex = arr.findIndex(
                (a) => a.mstTrackingNumber === item.mstTrackingNumber
              )
              item.id = `children-${item.orderId}-${index}`
              if (zIndex > -1) {
                arr[zIndex].children.push({
                  ...item,
                  isCheck: false // 是否勾选
                })
              } else {
                arr.push({
                  ...item,
                  isIndeterminate: false, // 是否不确定态
                  isCollapse: false, // 是否展开
                  isCheck: false, // 是否勾选
                  children: [item], // 子单号
                  id: `${item.orderId}-${index}`
                })
              }
            })
          const newArr = arr.map((a, i) => {
            return {
              ...a,
              index: type === 'init' ? i : this.segmentData.length + i
            }
          })
          if (type === 'init') {
            this.segmentData = newArr
          } else {
            data?.length && this.segmentData.push(...newArr)
            !data?.length && (this.segmentData = [])
            if (params.pageIndex * params.pageSize > this.segmentData.length) {
              this.listStatus = false
              this.state.complete()
            }
          }
        } else {
          this.segmentData = []
          this.listStatus = false
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        this.loading = false
        console.log(error)
      }
    },
    initList(containsArr) {
      this.pagerConfig = {
        pageIndex: 1,
        pageSize: 5000
      }
      this.containsArr = containsArr
      this.getUnbindList(this.pagerConfig, 'init')
    },
    // getDataSegment(array, segmentSize, segmentIndex) {
    //   const start = segmentIndex * segmentSize
    //   const end = start + segmentSize
    //   return array.slice(start, end)
    // },
    loadMore: throttle(async function($state) {
      // if (this.segmentData.length === this.list.length) {
      //   $state && $state.loaded()
      //   this.loading = false
      //   return
      // }
      this.state = $state
      if (!this.listStatus) {
        $state && $state.complete()
        return
      }
      this.pagerConfig = {
        pageIndex: this.pagerConfig.pageIndex + 1,
        pageSize: this.pagerConfig.pageSize
      }
      await this.getUnbindList(this.pagerConfig)
      // const segmentIndex = this.segmentIndex + 1
      // this.segmentIndex = segmentIndex
      // this.segmentData.push(...this.getDataSegment(this.list, 20, segmentIndex))
      $state && $state.loaded()
    }, 300),
    filterOrder(text) {
      const arr = []
      const data =
        text && text.length > 0
          ? sourceData.filter((item) => {
              return text.some(
                (a) =>
                  item.mstTrackingNumber.indexOf(a) > -1 ||
                  item.trackingNumber.indexOf(a) > -1 ||
                  item.masterOrderId.indexOf(a) > -1 ||
                  item.referenceNumber.split('-')[0].indexOf(a) > -1 ||
                  item.referenceNumber.indexOf(a) > -1
              )
            })
          : sourceData
      data.forEach((item, index) => {
        const zIndex = arr.findIndex(
          (a) => a.mstTrackingNumber === item.mstTrackingNumber
        )
        if (zIndex > -1) {
          arr[zIndex].children.push({
            ...item,
            isCheck: false, // 是否勾选
            id: `children-${item.orderId}-${index}`
          })
        } else {
          item.id = `children-${item.orderId}-${index}`
          arr.push({
            ...item,
            isIndeterminate: false, // 是否不确定态
            isCollapse: false, // 是否展开
            isCheck: false, // 是否勾选
            children: [item], // 子单号
            id: `${item.orderId}-${index}`
          })
        }
      })
      const newArr = arr.map((a, i) => {
        return {
          ...a,
          index: i
        }
      })
      this.list = newArr
      text && (this.segmentData = newArr)
    },
    filterOrderBySelected(selectedArr) {
      const arr = []
      const data =
        selectedArr.length > 0
          ? sourceData.filter((item) => {
              return !selectedArr.find((a) => {
                return (
                  a.mstTrackingNumber === item.mstTrackingNumber &&
                  a.trackingNumber === item.trackingNumber &&
                  a.referenceNumber === item.referenceNumber
                )
              })
            })
          : sourceData
      data.forEach((item) => {
        const zIndex = arr.findIndex(
          (a) => a.mstTrackingNumber === item.mstTrackingNumber
        )
        if (zIndex > -1) {
          arr[zIndex].children.push({
            ...item,
            isCheck: false // 是否勾选
          })
        } else {
          arr.push({
            ...item,
            isIndeterminate: false, // 是否不确定态
            isCollapse: false, // 是否展开
            isCheck: false, // 是否勾选
            children: [item] // 子单号
          })
        }
      })
      this.dataList = arr
    },
    open(index, flag) {
      this.segmentData = this.segmentData.map((a) => {
        return { ...a, isCollapse: false }
      })
      this.$set(this.segmentData, index, {
        ...this.segmentData[index],
        isCollapse: !flag
      })
    },
    handleCheckAllChange(index) {
      const children = this.segmentData[index].children.map((item) => {
        return {
          ...item,
          isCheck: this.segmentData[index].isCheck
        }
      })
      const mstOrder = {
        ...this.segmentData[index],
        isIndeterminate: false,
        children
      }
      this.$set(this.segmentData, index, mstOrder)
      this.selectItems()
    },
    handleCheckOrderChange(index) {
      const isCheckLength = this.segmentData[index].children.filter(
        (a) => a.isCheck === true
      ).length
      const mstOrder = {
        ...this.segmentData[index],
        isIndeterminate: !(
          isCheckLength === this.segmentData[index].children.length ||
          isCheckLength === 0
        ),
        isCheck: isCheckLength === this.segmentData[index].children.length
      }
      this.$set(this.segmentData, index, mstOrder)
      this.selectItems()
    },
    checkAll() {
      const list = this.segmentData.map((item) => {
        const children = item.children.map((a) => {
          return {
            ...a,
            isCheck: true
          }
        })
        return {
          ...item,
          isCheck: true,
          children
        }
      })
      this.segmentData = list
      this.selectItems()
    },
    unCheckAll() {
      const list = this.segmentData.map((item) => {
        const children = item.children.map((a) => {
          return {
            ...a,
            isCheck: false
          }
        })
        return {
          ...item,
          isCheck: false,
          children
        }
      })
      this.segmentData = list
      this.selectItems()
    },
    selectItems() {
      const dataList = this.segmentData
      const arr = []
      dataList.forEach((item) => {
        if (item.isCheck && !item.isIndeterminate) {
          arr.push(item)
        } else if (item.isIndeterminate) {
          const children = item.children.filter((a) => a.isCheck === true)
          if (children.length > 0) {
            arr.push({
              ...item,
              children
            })
          }
        }
      })
      this.$emit('selectItems', arr)
    }
  }
}
</script>
<style lang="less" scoped>
:deep(.no-empty) {
  .el-table__empty-block {
    display: none;
  }
}
/deep/ .el-table__row {
  position: relative;
  height: 60px;
  background: #ffffff;
  box-shadow: 0px 0px 6px 1px rgba(0, 0, 0, 0.08);
  border-radius: 4px 4px 4px 4px;
  td {
    position: initial;
  }
}
/deep/ .el-table__cell {
  position: initial;
}
/deep/ .el-table__body {
  border-spacing: 2px 15px !important;
  .content {
    position: absolute;
    left: 0;
    top: 62.4px;
    width: 100%;
    margin: 0 auto;
    height: auto;
    z-index: 999;
    background: #ffffff;
    box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.08);
    border-radius: 0 4px 0 4px;
    padding: 16px;
    box-sizing: border-box;
  }
  .title {
    height: 48px;
    background: #fbfbfb;
    border-radius: 6px;
    text-indent: 32px;
    font-size: 14px;
    font-weight: 400;
    color: #666666;
    line-height: 48px;
    text-align: left;
  }
  .order-items {
    width: calc(100% - 200px);
    margin: 0 auto;
    padding-top: 24px;
    display: flex;
    flex-wrap: wrap;
  }
  .order {
    width: 24.666%;
    margin-bottom: 24px;
    font-size: 14px;
    font-weight: 400;
    color: #25396f;
    line-height: 19px;
    min-width: 200px;
    .lable {
      margin-left: 16px;
    }
  }
  .checked {
    color: #666666;
  }
  .uncheck {
    color: #999999;
  }
}
/deep/ .el-el-table__header {
  border-spacing: 2px 15px !important;
}
.table {
  width: 100%;
  height: 100%;
  .header {
    width: 100%;
    height: 48px;
    border-radius: 6px;
    background: #fff;
    display: flex;
    .cell {
      background: #f8fbff;
      width: 20%;
      height: 48px;
      line-height: 48px;
      text-align: center;
      &:first-child {
        width: 30%;
      }
      &:last-child {
        width: 10%;
      }
    }
    .scoll {
      width: 10px;
    }
  }
  .cell {
    width: 20%;
  }
  .tbody {
    width: 100%;
    height: 400px;
    overflow: auto;
    .row {
      width: calc(100% - 2px);
      min-height: 58px;
      background: #ffffff;
      box-shadow: 0px 0px 6px 1px rgba(0, 0, 0, 0.05);
      border-radius: 6px;
      margin-top: 16px;
      &:last-child {
        margin-bottom: 5px;
      }
      & .top {
        display: flex;
        min-height: 58px;
      }
    }
    .cell {
      height: 19px;
      font-size: 14px;
      font-weight: 400;
      color: #25396f;
      line-height: 58px;
      text-align: center;
      position: relative;
      &:first-child {
        width: 30%;
      }
      &:last-child {
        width: 10%;
      }
    }
    .checkBox {
      position: absolute;
      left: 20px;
    }
  }
}
</style>
